import { ContractRelatedDocument } from 'services/ApiService/Franfinance/FranfinanceApiClient';
import { FileAndType } from 'services/FileService';
import { Reducer, SirenDictionnaryType, sirenStatePatcher } from 'store/configureStore';
import { ApiRequest } from 'store/sharedModels';

export const documentContractRelatedInitialState = {
    contractIds: [] as string[],
    documents: [] as ContractRelatedDocument[],
    request: {
        isFetching: false,
    } as ApiRequest<string[]>,
    files: [] as FileAndType[],
    optionalCommentary: '' as string,

} as const;

export type DocumentContractRelatedState = typeof documentContractRelatedInitialState;
export const sirenDocumentContractRelatedInitialState: SirenDictionnaryType<DocumentContractRelatedState> = {};

export const DocumentContractRelatedReducer: Reducer<SirenDictionnaryType<DocumentContractRelatedState>> = (state = sirenDocumentContractRelatedInitialState, action) => {
    switch (action.type) {
        case '@CUSTOMER_SERVICE/DOCUMENT/CONTRACT_RELATED/SET_FORM_VALUE':
            return sirenStatePatcher(state, action.payload.siren, {
                contractIds: action.payload.contractIds,
                documents: action.payload.documents,
                files: action.payload.files,
                optionalCommentary: action.payload.optionalCommentary,
            });
        case '@CUSTOMER_SERVICE/DOCUMENT/CONTRACT_RELATED/SUBMIT':
            return sirenStatePatcher(state, action.payload.siren, {
                request: {
                    ...state[action.payload.siren]?.request,
                    isFetching: true,
                },
            });
        case '@CUSTOMER_SERVICE/DOCUMENT/CONTRACT_RELATED/SUBMIT_SUCCESS':
            return sirenStatePatcher(state, action.payload.siren, {
                ...documentContractRelatedInitialState,
                request: {
                    ...state[action.payload.siren]?.request,
                    isFetching: false,
                },
            });
        case '@CUSTOMER_SERVICE/DOCUMENT/CONTRACT_RELATED/SUBMIT_FAILURE':
            return sirenStatePatcher(state, action.payload.siren, {
                request: {
                    ...state[action.payload.siren]?.request,
                    isFetching: false,
                },
            });
        default:
            return state;

    }
};